exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".data-view-group{margin-bottom:10px}.data-view-group div:first-child{text-align:right}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Foundation/screens/MyData/components/ViewDataItem/style.css
 ** module id = 1411
 ** module chunks = 4 5 6 8 9
 **/